import React, {
  forwardRef,
  Ref,
  useId,
  useState,
  useImperativeHandle,
  useCallback,
} from 'react';

// Types
import { InputBudgetCodeProps, ImperativeRefInputBudgetCode } from './types';

// Components Styled
import { Container, InputValue, Label } from './styles';

// Media
import { useIsLandscapeTablet } from '../../../hooks/useMediaBreakPoints';
import isEqual from 'lodash.isequal';

/**
 * Primary UI component for budget code filtering (6 digits)
 */
function InputBudgetCode(
  {
    label = 'Budget Code',
    disabled,
    onChangeInputBudgetCode,
    budgetCode,
    ...props
  }: InputBudgetCodeProps,
  innerRef: Ref<ImperativeRefInputBudgetCode>
): JSX.Element {
  const [inputValue, setInputValue] = useState<string>(budgetCode || '');

  const onChangeInput = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      const value = event.target.value;

      // Solo permitir números y letras, máximo 6 caracteres
      if (value === '' || /^[a-zA-Z0-9]{0,6}$/.test(value)) {
        setInputValue(value);
        onChangeInputBudgetCode(value === '' ? undefined : value);
      }
    },
    [onChangeInputBudgetCode]
  );

  useImperativeHandle(innerRef, () => ({
    clearSelected: () => {
      setInputValue('');
      onChangeInputBudgetCode(undefined);
    },
  }));

  const id = useId();
  const isLandscapeTablet = useIsLandscapeTablet();

  return (
    <Container {...props}>
      {label && (
        <Label
          component={'label'}
          htmlFor={`${id}-budget-code-input`}
          colorText="black"
          size={isLandscapeTablet ? 'XS' : 'S'}
        >
          {label}
        </Label>
      )}
      <InputValue
        id={`${id}-budget-code-input`}
        type="text"
        disabled={disabled}
        maxLength={6}
        placeholder={'000000'}
        value={inputValue}
        onChange={onChangeInput}
        onKeyDown={(e) => {
          // Prevenir caracteres especiales
          /[+*./,\\-]/.test(e.key) && e.preventDefault();
        }}
      />
    </Container>
  );
}

export default React.memo(forwardRef(InputBudgetCode), isEqual);
